"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearPreviewImageHost = exports.populatePreviewImage = exports.DragImagePreviewHostElement = void 0;
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./DragPreviewImageHost.css"));
var DIProvider_1 = require("@CommonFrontend/DIProvider/DIProvider");
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
var classnames_1 = __importDefault(require("classnames"));
exports.DragImagePreviewHostElement = (0, DIProvider_1.makeServiceIdentifier)(Symbol("DragImagePreviewHost"));
var DRAG_HANDLE_HORIZONTAL_OFFSET = 12;
var DRAG_HANDLE_VERTICAL_OFFSET = 12;
var populatePreviewImage = function (_a) {
    var _b, _c;
    var hostElement = _a.hostElement, selection = _a.selection, focalElementIndex = _a.focalElementIndex;
    hostElement.innerHTML = "";
    var hostRect = hostElement.getBoundingClientRect();
    var previewElementDragHandlePositions = [];
    var previewElementInvisibleOverflowPositions = [];
    for (var i = 0; i < selection.length; i++) {
        var sel = selection[i];
        if (!sel)
            continue;
        var originalNode = slate_react_1.ReactEditor.toDOMNode(sel.editor, slate_1.Editor.node(sel.editor, sel.path)[0]);
        var clonedNode = slate_react_1.ReactEditor.toDOMNode(sel.editor, slate_1.Editor.node(sel.editor, sel.path)[0]).cloneNode(true);
        if (!(clonedNode instanceof HTMLElement))
            continue;
        var maybeOriginalNodeConstrainingDiv = originalNode.querySelector('[data-width-constraining-div],[data-slate-node="element"]');
        if (maybeOriginalNodeConstrainingDiv instanceof HTMLElement &&
            maybeOriginalNodeConstrainingDiv.hasAttribute("data-width-constraining-div")) {
            var originalNodeConstrainingDivRect = maybeOriginalNodeConstrainingDiv.getBoundingClientRect();
            var elementRect = (_b = maybeOriginalNodeConstrainingDiv.parentElement) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
            if (elementRect) {
                var ratio = originalNodeConstrainingDivRect.width / elementRect.width;
                var newWidth = ratio * hostRect.width;
                var adjustedWidth = newWidth;
                var clonedNodeWidthConstrainingDiv = clonedNode.querySelector("[data-width-constraining-div]");
                if (clonedNodeWidthConstrainingDiv instanceof HTMLElement) {
                    clonedNodeWidthConstrainingDiv.style.width = "".concat(adjustedWidth, "px");
                }
            }
        }
        var clonedNodeDragHandle = clonedNode.querySelector("[data-drag-handle]");
        if (!(clonedNodeDragHandle instanceof HTMLElement))
            continue;
        if (i === focalElementIndex) {
            clonedNodeDragHandle.style.opacity = "1";
        }
        var nodeElementsForRemoval = clonedNode.querySelectorAll("[data-remove-from-drag-preview]");
        nodeElementsForRemoval.forEach(function (element) { return element.remove(); });
        hostElement.appendChild(clonedNode);
        var _d = clonedNodeDragHandle.getBoundingClientRect(), left = _d.left, top = _d.top;
        previewElementDragHandlePositions.push({ left: left, top: top });
        var circleImage = clonedNode.querySelector(".image-widget__frame--circle .image-widget__container");
        if (circleImage) {
            var _e = circleImage.getBoundingClientRect(), imageLeft = _e.left, imageTop = _e.top;
            previewElementInvisibleOverflowPositions.push({ left: imageLeft, top: imageTop });
        }
    }
    var focalElementRect = (_c = previewElementDragHandlePositions[focalElementIndex]) !== null && _c !== void 0 ? _c : { left: 0, top: 0 };
    var widestElementLeft = Math.min.apply(Math, __spreadArray([], __read(previewElementDragHandlePositions.map(function (rect) { return rect.left; })), false));
    var focalElementLeft = focalElementRect.left - Math.min(hostRect.left, widestElementLeft);
    var focalElementTop = focalElementRect.top - hostRect.top;
    var invisibleElementLeftOffset = 0;
    var invisibleElementTopOffset = 0;
    if (previewElementInvisibleOverflowPositions.length > 0) {
        var widestInvisibleElementLeft = Math.min.apply(Math, __spreadArray([], __read(previewElementInvisibleOverflowPositions.map(function (rect) { return rect.left; })), false));
        var highestInvisibleElementTop = Math.min.apply(Math, __spreadArray([], __read(previewElementInvisibleOverflowPositions.map(function (rect) { return rect.top; })), false));
        if (widestInvisibleElementLeft < widestElementLeft && widestInvisibleElementLeft < hostRect.left) {
            invisibleElementLeftOffset = widestElementLeft - widestInvisibleElementLeft;
        }
        if (highestInvisibleElementTop < hostRect.top) {
            invisibleElementTopOffset = hostRect.top - highestInvisibleElementTop;
        }
    }
    var browserSpecificTopOffset = 0;
    var browserSpecificLeftOffset = 0;
    if (/firefox/i.test(navigator.userAgent)) {
        if (invisibleElementTopOffset === 0) {
            browserSpecificTopOffset = 20;
        }
        if (invisibleElementLeftOffset === 0 && widestElementLeft < hostRect.left) {
            browserSpecificLeftOffset = 40;
        }
    }
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        if (widestElementLeft < hostRect.left) {
            browserSpecificLeftOffset = -1 * (hostRect.left - widestElementLeft);
        }
        invisibleElementLeftOffset = 0;
        invisibleElementTopOffset = 0;
    }
    return {
        offsetLeft: focalElementLeft + DRAG_HANDLE_HORIZONTAL_OFFSET + browserSpecificLeftOffset + invisibleElementLeftOffset,
        offsetTop: focalElementTop + DRAG_HANDLE_VERTICAL_OFFSET + browserSpecificTopOffset + invisibleElementTopOffset,
    };
};
exports.populatePreviewImage = populatePreviewImage;
var DragPreviewImageHost = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var className = _a.className;
    var _c = __read((0, react_1.useState)(), 2), width = _c[0], setWidth = _c[1];
    var rulerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (rulerRef.current) {
            var _a = (0, observe_rect_1.default)(rulerRef.current, function (_a) {
                var width = _a.width;
                setWidth(width);
            }), observe = _a.observe, unobserve_1 = _a.unobserve;
            observe();
            return function () {
                unobserve_1();
            };
        }
        return undefined;
    }, []);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.wrapper, className) },
        react_1.default.createElement("div", { ref: rulerRef }),
        react_1.default.createElement("div", { className: styles.host, ref: ref, style: (0, dynamic_1.assignInlineVars)((_b = {}, _b[styles.width] = width ? "".concat(width, "px") : "unset", _b)) })));
});
var clearPreviewImageHost = function (hostElement) {
    hostElement.innerHTML = "";
};
exports.clearPreviewImageHost = clearPreviewImageHost;
exports.default = DragPreviewImageHost;
